import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/products/ai-product-recommendation"
    path="business/products/ai-product-recommendation"
    element={<AsyncPage />}
  />,
];
